/**
 * @description: 商品免单规则设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="commodity-free-rule">
        <div class="cfr-list" v-show="showList">
            <h1>商品免单规则设置</h1>
            <el-row class="row-margin" v-if="list_menu_add">
				<el-button type="primary" @click="cfrAdd">新增商品免单规则</el-button>
			</el-row>
            <p>注：设置商品免单规则后，APP收银操作商品免单时可选择对应规则进行商品免单</p>
            <el-form :inline="true" :model="list_form">
				<el-form-item label="门店">
					<el-select v-model="list_form.shop_id" filterable placeholder="请选择门店">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="规则名称">
					<el-input placeholder="请输入规则名称" v-model="list_form.name"></el-input>
				</el-form-item>
				<el-form-item class="pull-right">
					<el-button type="primary" @click="listQuery">查询</el-button>
				</el-form-item>
			</el-form>
            <el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="list_table">
				<el-table-column type="index" label="行号"></el-table-column>
				<el-table-column prop="name" label="规则名称"></el-table-column>
				<el-table-column prop="shop_name" label="适用门店"></el-table-column>
				<el-table-column prop="room_name" label="适用包厢">
					<template slot-scope="scope">
						{{scope.row.room_name.split(',').length > 5 ? scope.row.room_name.split(',').slice(0, 5).join(',') + '...' : scope.row.room_name}}
					</template>
				</el-table-column>
				<el-table-column prop="use_date" label="使用日期"></el-table-column>
                <el-table-column prop="use_date_time" label="使用时间"></el-table-column>
                <el-table-column prop="week_cycle_str" label="适用星期几"></el-table-column>
                <el-table-column prop="apply_role_names" label="适用角色"></el-table-column>
                <el-table-column prop="goods_name" label="适用商品"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" v-if="list_menu_modify" @click="cfrModify(scope.row.id)">修改</span>
						<span class="text-blue" v-if="list_menu_del" @click="cfrDel(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="list_page"
				:total="list_total"
				@current-change="getListTable">
			</el-pagination>
        </div>
        <div class="cfr-edit" v-show="showEdit">
            <div class="page-tit">{{edit_tit}}</div>
			<el-form ref="edit_form" :model="edit_form" label-width="120px">
				<el-form-item label="门店">
					<el-select v-model="edit_form.shop_id" :disabled="edit_form.shop_disabled" filterable placeholder="请选择门店" @change="cfrShopChange">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="规则名称">
					<el-input placeholder="请输入规则名称" v-model="edit_form.name"></el-input>
				</el-form-item>
                <el-form-item label="适用包厢">
                    <el-input v-model="room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="roomSelect" @clear="roomDel"></el-input>
				</el-form-item>
				<el-form-item label="使用日期" class="cfr-usedate-wrap">
					<div ref="usedate_main">
						<el-input v-model="usedate_txt" class="el-ellipsis" placeholder="请选择使用日期"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="使用时间">
					<el-input v-model="edit_form.usetime_txt" class="el-ellipsis" placeholder="请选择使用时间" @click.native="openUsetime"></el-input>
				</el-form-item>
				<el-form-item label="有效星期几">
                    <el-input v-model="week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="weekSelect" @clear="weekDel"></el-input>
				</el-form-item>
				<el-form-item label="适用角色">
                    <el-input v-model="role_txt" class="el-ellipsis" clearable placeholder="请选择适用角色" @focus="roleSelect" @clear="roleDel"></el-input>
				</el-form-item>
				<el-form-item label="适用商品">
					<el-radio-group v-model="set_type">
					    <el-radio label="1">按商品添加</el-radio>
					    <el-radio label="2">按类型添加</el-radio>
					</el-radio-group>
                    <el-input v-model="goods_txt" class="el-ellipsis" clearable placeholder="请选择适用商品" @focus="goodsSelect" @clear="goodsDel" v-show="set_type=='1'"></el-input>
                    <el-input v-model="types_txt" class="el-ellipsis" clearable placeholder="请选择适用类型" @focus="typesSelect" @clear="typesDel" v-show="set_type=='2'"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="backList">返回</el-button>
					<el-button type="primary" @click="editSub">确定</el-button>
				</el-form-item>
			</el-form>
			<!-- 使用时间 -->
			<div class="use-time-wrap" ref="usetime_alert">
				<h2>开始时间：</h2>
				<select ref="starthour"></select>
				<label class="colon">:</label>
				<select ref="startseconds"></select>
				<h2>结束时间：</h2>
				<select ref="stophour"></select>
				<label class="colon">:</label>
				<select ref="stopseconds"></select>
			</div>
			<!-- 星期 -->
			<div class="export-wrap" ref="week_alert">
				<el-checkbox :indeterminate="week_sign" v-model="week_all" @change="weekAll">全选</el-checkbox>
				<el-checkbox-group v-model="week_ids" @change="weekChange">
					<el-checkbox label="1">星期一</el-checkbox>
					<el-checkbox label="2">星期二</el-checkbox>
					<el-checkbox label="3">星期三</el-checkbox>
					<el-checkbox label="4">星期四</el-checkbox>
					<el-checkbox label="5">星期五</el-checkbox>
					<el-checkbox label="6">星期六</el-checkbox>
					<el-checkbox label="0">星期日</el-checkbox>
				</el-checkbox-group>
			</div>
			<!-- 适用角色 -->
			<div class="export-wrap role-pop" ref="role_alert">
				<el-checkbox :indeterminate="role_sign" v-model="role_all" @change="roleAll">全选</el-checkbox>
				<el-checkbox-group v-model="role_ids" @change="roleChange">
					<el-checkbox v-for="item in role_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<!-- 适用商品 -->
			<div class="select-goods-wrap" ref="goods_alert">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select v-model="goods_type_name" clearable filterable placeholder="请选择类型" @change="goodsTypeChange($event)">
							<el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item"></el-option>
						</el-select>
					</el-col>
					<el-col :span="10">
						<el-input placeholder="请输入商品名称" v-model="goods_name"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button class="pull-right" type="primary" @click="goodsQuery">查询</el-button>
					</el-col>
				</el-row>
				<el-table
					v-loading="loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					ref="goods_table"
					:data="goods_table"
					@selection-change="getSelectGoods">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="goods_type_name" label="类型"></el-table-column>
					<el-table-column
						v-for="(item, index) in goods_columns"
						:key="index"
						:prop="item.prop"
						:label="item.label">
					</el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="goods_page"
					:total="goods_total"
					@current-change="getGoodsTable">
				</el-pagination>
			</div>
			<!-- 商品类型 -->
			<div class="goods-type-pop ele-hide" ref="goods_type_pop">
				<el-checkbox v-model="goods_type_all" @change="typesAll">全选</el-checkbox>
				<el-checkbox-group v-model="choosed_goods_type" @change="typesChange">
					<el-checkbox v-for="item in goods_type_arr" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
        </div>
		<!-- 包厢号 -->
		<div class="multi-page" v-show="showRoom">
			<div class="page-tit">选择包厢</div>
			<p>请选择包厢范围</p>
			<div class="multi-page-main">
				<div class="multi-page-row">
					<div>
						<input type="checkbox" v-model='room_all' @click='roomAll'>
						<span>全部</span>
					</div>
					<ul></ul>
				</div>
				<div class="multi-page-row" v-for="(items, index) in room_arr" :key="items.room_area">
					<div>
						<input type="checkbox" v-model='room_floor' :value="items.room_area" @click="roomFloor(items.room_area, index)">
						<span>{{items.room_area_name}}</span>
					</div>
					<ul class="clearfix">
						<li v-for="item in items.room" :key="item.id">
							<input type="checkbox" v-model='room_item' :value="item.id">
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="roomBack()">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="roomSave()">确定</button>
			</div>
		</div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showList: true,
				showEdit: false,
				showRoom: false,
                loading: false,
                shop_list: [],

				list_menu_add: false,
            	list_menu_modify: false,
				list_menu_del: false,
				list_form: {
                    shop_id: '',
                    name: ''
				},
				list_page: 1,
				list_total: 0,
				list_table: [],

				modify: '1',
				edit_id: '',
				edit_tit: '',
				edit_form: {
					shop_id: '',
					shop_disabled: false,
					name: '',
					usetime_txt: '',
					use_start_time: '',
					use_end_time: '',
				},
				room_txt: '',
				use_all_room: -1,
				room_all: false,
				c_room_all: false,
				room_item: [],
				c_room_item: [],
				room_floor: [],
				c_room_floor: [],
				room_arr: [],
				room_arr_det: [],
				usedate_txt: '',
				use_every_day: -1,
				usedate_start: '',
				usedate_end: '',
                week_txt: '',
				week_sign: false,
				week_all: false,
				week_ids: [],
				week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
                role_txt: '',
				role_sign: false,
				role_all: false,
                role_ids: [],
				role_list: [],
				goods_txt: '',
				goods_select: [],
				goods_type: '',
				goods_type_name: '',
				goods_type_sign: '',
				goods_type_list: [],
				goods_name: '',
				goods_page: 1,
				goods_total: 0,
				goods_columns: [],
				goods_table: [],
				goods_table_select: [],
				set_type: '1',
				types_txt: '',
				goods_type_arr: [], // 全部商品类型
				goods_type_all: false,
				choosed_goods_type: [], // 选择的商品类型
            }
		},
		watch: {
			room_item: {
				handler: function(val, oldVal) {
					const _this = this;

					if(_this.room_item.length >= _this.room_arr_det.length) {
						_this.room_all = true;
						_this.c_room_all = _this.room_all;
					} else {
						_this.room_all = false;
						_this.c_room_all = _this.room_all;
					}

					$.each(_this.room_arr, function(k, v) {
						if(_this.room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.room_floor.indexOf(v.room_area) == -1) {
										_this.room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.room_floor.splice(index, 1);
							}
						}
					});
					_this.c_room_floor = _this.room_floor;
				},
				deep: true
			}
		},
        created: function() {
			this.getMenuOp()
			this.getShop();
		},
        mounted: function() {
			this.getListTable(1);

			this.initDate();
			this.initTime();
			this.getRole();
			this.getGoodsPackageType();
			this.getAllGoodsType();
        },
        methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = JSON.parse(this.$store.state.menunew);

				menu.forEach(f => {
					if(f.id == '542') {
						menu = f.submenu
						menu.forEach(s => {
							if(s.id == '905') {
								menu = s.submenu
							}
						})
					}
				})
				menu.forEach(_ => {
					if(_.id == '948') {
						_this.list_menu_add = true
					}
					if(_.id == '949') {
						_this.list_menu_modify = true
					}
					if(_.id == '950') {
						_this.list_menu_del = true
					}
				})
			},
            // 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 获取角色
			getRole() {
				const _this = this;

				Vue.axios.post('PublicData/api_getMerchantRole', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.role_list = res.data.response.data;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            // 列表
			getListTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FreeGoods/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.list_form.shop_id,
                            "name": _this.list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total);
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			listQuery() {
				this.getListTable(1);
			},
			// 删除
			cfrDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('FreeGoods/delData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getListTable(_this.list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
			},
			// 点击新增
			cfrAdd() {
				const _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增商品免单规则';
				_this.edit_form = {
					shop_id: _this.shop_list[0].id,
					shop_disabled: false,
					name: '',
					usetime_txt: '',
					use_start_time: '',
					use_end_time: ''
				};
				new Promise(resolve => {
					_this.getRoom(_this.edit_form.shop_id, resolve)
				})
				.then(res => {
					_this.room_txt = '';
					_this.use_all_room = -1;
					_this.room_item = [];
				})
				_this.usedate_txt = ''
				_this.use_every_day = -1,
				_this.usedate_start = ''
				_this.usedate_end = ''
                _this.week_txt = ''
				_this.week_ids = []
                _this.role_txt = ''
                _this.role_ids = []
				_this.goods_txt = ''
				_this.goods_select = []
				_this.showList = false;
				_this.showEdit = true;
				_this.set_type = '1';
				_this.types_txt = '';
				_this.choosed_goods_type = [];
				_this.goods_type_all = false;
			},
			// 点击修改
			cfrModify(id) {
				const _this = this;

				_this.modify = '2';
				_this.edit_tit = '修改商品免单规则';
				Vue.axios.post('FreeGoods/getData', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						const row = res.data.response.data;
						_this.edit_id = row.id;
						_this.edit_form.shop_id = row.shop_id;
						_this.edit_form.shop_disabled = true;
						_this.edit_form.name = row.name;
						new Promise(resolve => {
							_this.getRoom(_this.edit_form.shop_id, resolve)
						})
						_this.room_txt = row.room_name
						_this.use_all_room = row.use_all_room
						if(row.use_all_room == 1) {
							_this.room_item = [];
							_this.room_arr_det.forEach(item => {
								_this.room_item.push(item.id);
							});
						} else {
							_this.room_item = row.room_ids.split(',')
						}
						_this.usedate_txt = row.use_date;
						_this.use_every_day = row.use_every_day;
						_this.usedate_start = row.start_date;
						_this.usedate_end = row.end_date;
						if(row.use_every_day == 1) {
							$(".usedate-everyday input").val("1");
							$(".usedate-everyday input").prop("checked", true);
						} else {
							$(".usedate-everyday input").val("");
							$(".usedate-everyday input").prop("checked", false);
						}
						_this.edit_form.usetime_txt = row.use_date_time;
						_this.edit_form.use_start_time = row.use_start_time;
						_this.edit_form.use_end_time = row.use_end_time;
						_this.week_ids = row.week_cycle.split(',')
						_this.week_sign = _this.week_ids.length > 0 && _this.week_ids.length < _this.week_list.length;
						_this.week_all = _this.week_ids.length === _this.week_list.length;
						let week_txt = [];
						_this.week_list.forEach(_ => {
							_this.week_ids.forEach(item => {
								if(_.id == item) {
									week_txt.push(_.name);
								}
							});
						});
						_this.week_txt = week_txt.join(',');
						_this.role_txt = row.apply_role_names
						if(row.apply_role_ids == '-1') {
							_this.role_ids = [];
							_this.role_list.forEach(_ => {
								_this.role_ids.push(_.id)
							});
						} else {
							_this.role_ids = row.apply_role_ids.split(',')
						}
						_this.role_sign = _this.role_ids.length > 0 && _this.role_ids.length < _this.role_list.length;
						_this.role_all = _this.role_ids.length === _this.role_list.length;
						_this.set_type = row.set_type
						if (row.set_type == '1') { // 商品
							_this.goods_select = row.goods_infos
							let goods_txt = []
							row.goods_infos.forEach(_ => {
								goods_txt.push(_.goods_name)
							});
							_this.goods_txt = goods_txt.join(',')
						}else { // 类型
							_this.choosed_goods_type = []
							let types_txt = []
							row.goods_type.forEach(item => {
								_this.choosed_goods_type.push(item.id)
								types_txt.push(item.name)
							})
							_this.types_txt = types_txt.join(',')
						}
						_this.showList = false;
						_this.showEdit = true;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			cfrShopChange(val) {
				new Promise(resolve => {
					this.getRoom(val, resolve)
				})
				this.room_txt = '';
				this.use_all_room = -1;
				this.room_item = [];
			},
			// 获取包厢号
			getRoom: function(shop_id, resolve) {
				const _this = this;

				Vue.axios.post('Shop/getAllRoomByArea', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.room_arr = res.data.response.result;
						_this.room_arr_det = [];
						res.data.response.result.forEach(_ => {
							_.room.forEach(item => _this.room_arr_det.push(item))
						});
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 点击选择包厢号
			roomSelect: function(e) {
				this.c_room_item = this.room_item;
				this.c_room_all = this.room_all;
				this.showEdit = false;
				this.showRoom = true;
			},
			roomDel() {
				this.room_txt = '';
				this.use_all_room = -1;
				this.room_item = [];
			},
			// 全选
			roomAll: function() {
				const _this = this;
				_this.room_all = _this.c_room_all;
				if(!_this.room_all) { // 实现全选
					_this.room_item = [];
					_this.room_arr_det.forEach(item => {
						_this.room_item.push(item.id);
					});
				} else { // 实现反选
					_this.room_item = [];
				}
			},
			// 楼层全选/反选
			roomFloor: function(id, index) {
				const _this = this;

				_this.room_floor = _this.c_room_floor;
				if(_this.room_floor.indexOf(id) == -1) {
					_this.room_arr[index].room.forEach(item => {
						if(_this.room_item.indexOf(item.id) == -1) {
							_this.room_item.push(item.id);
						}
					});
				} else {
					_this.room_arr[index].room.forEach(item => {
						let index = '';
						index = _this.room_item.indexOf(item.id);
						if(index != -1) {
							_this.room_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			roomSave: function() {
				const _this = this;

				if(_this.room_all) {
					_this.room_txt = '全部';
					_this.use_all_room = 1;
				} else {
					let texts = [];
					_this.room_arr_det.forEach(_ => {
						_this.room_item.forEach(item => {
							if(_.id == item) {
								texts.push(_.name);
							}
						});
					});
					_this.room_txt = texts.join(",");
					_this.use_all_room = -1;
				}
				_this.showEdit = true;
				_this.showRoom = false;
			},
			// 返回
			roomBack: function() {
				this.room_item = this.c_room_item;
				this.showEdit = true;
				this.showRoom = false;
			},
			// 使用日期
			initDate: function() {
				const _this = this;
				$(_this.$refs.usedate_main).daterangepicker({
					parentEl: '.cfr-usedate-wrap',
					// drops: 'down',
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
				}, function(start, end, label) {
					event.preventDefault()
					_this.usedate_start = start.format('YYYY-MM-DD');
					_this.usedate_end = end.format('YYYY-MM-DD');
					if($(".usedate-everyday input").val() == "1") {
						_this.usedate_txt = '每天';
						_this.use_every_day = 1;
					} else {
						_this.usedate_txt = _this.usedate_start + ' ~ ' + _this.usedate_end;
						_this.use_every_day = -1;
					}
				});
				$(".cfr-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
					'<div class="usedate-everyday">' +
						'<input type="checkbox" />' +
						'<label>每天</label>' +
					'</div>'
				);
				$(".usedate-everyday input").click(function() {
					if($(this).val() == "1") {
						$(this).prop("checked", false);
						$(this).val('');
					} else {
						$(this).prop("checked", true);
						$(this).val('1');
					}
				});
			},
			// 使用时间
			initTime: function() {
				const _this = this;

				let seconds = [];
				for(let i = 0; i < 60; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					seconds[i] = item;
				};
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				})
			},
			openUsetime: function() {
				const _this = this;
				$(_this.$refs.starthour).val(_this.edit_form.use_start_time.split(':')[0]).trigger('change');
				$(_this.$refs.startseconds).val(_this.edit_form.use_start_time.split(':')[1]).trigger('change');
				$(_this.$refs.stophour).val(_this.edit_form.use_end_time.split(':')[0]).trigger('change');
				$(_this.$refs.stopseconds).val(_this.edit_form.use_end_time.split(':')[1]).trigger('change');
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.usetime_alert)
				}, function() {
					let starthour = $(_this.$refs.starthour).select2("val");
					let startseconds = $(_this.$refs.startseconds).select2("val");
					let stophour = $(_this.$refs.stophour).select2("val");
					let stopseconds = $(_this.$refs.stopseconds).select2("val");
					_this.edit_form.use_start_time = starthour + ":" + startseconds;
					_this.edit_form.use_end_time = stophour + ":" + stopseconds;
					if(_this.edit_form.use_start_time == '00:00' && _this.edit_form.use_end_time == '00:00') {
						_this.edit_form.usetime_txt = '全天';
						// _this.edit_form.use_all_day = '1';
					} else {
						_this.edit_form.usetime_txt = _this.edit_form.use_start_time + " ~ " + _this.edit_form.use_end_time;
						// _this.edit_form.use_all_day = '-1';
					}
					layer.closeAll();
				});
			},
			// 星期
            weekSelect() {
                const _this = this;
                const c_week_ids = _this.week_ids,
                    c_week_sign = _this.week_sign,
                    c_week_all = _this.week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.week_ids = c_week_ids;
                        _this.week_sign = c_week_sign;
                        _this.week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.week_ids = c_week_ids;
                    _this.week_sign = c_week_sign;
                    _this.week_all = c_week_all;
                });
            },
            weekDel() {
				this.week_sign = false;
                this.week_all = false;
				this.week_ids = [];
            },
            weekAll(val) {
                let ids = [];
				this.week_list.forEach(v => {
					ids.push(v.id);
				});
				this.week_ids = val ? ids : [];
				this.week_sign = false;
			},
			weekChange(val) {
				const len = val.length;
				this.week_sign = len > 0 && len < this.week_list.length;
				this.week_all = len === this.week_list.length;
            },
			// 角色
            roleSelect() {
                const _this = this;
                const c_role_ids = _this.role_ids,
                    c_role_sign = _this.role_sign,
                    c_role_all = _this.role_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择角色', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.role_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.role_ids = c_role_ids;
                        _this.role_sign = c_role_sign;
                        _this.role_all = c_role_all;
                    }
                }, function() {
                    let arr = [];
                    _this.role_list.forEach(item => {
                        _this.role_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.role_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.role_ids = c_role_ids;
                    _this.role_sign = c_role_sign;
                    _this.role_all = c_role_all;
                });
            },
            roleDel() {
				this.role_sign = false;
                this.role_all = false;
				this.role_ids = [];
            },
            roleAll(val) {
                let ids = [];
				this.role_list.forEach(v => {
					ids.push(v.id);
				});
				this.role_ids = val ? ids : [];
				this.role_sign = false;
			},
			roleChange(val) {
				const len = val.length;
				this.role_sign = len > 0 && len < this.role_list.length;
				this.role_all = len === this.role_list.length;
			},
			// 适用商品
			goodsSelect: function() {
				const _this = this;

				_this.goods_type = '';
				_this.goods_type_name = '';
				_this.goods_type_sign = '';
				_this.goods_name = '';
				_this.goods_page = 1;
				_this.getGoodsTable(1);
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择适用商品', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.goods_alert)
                }, function() {
					// 保存商品
					if(_this.goods_type_sign == 'package') {
						_this.goods_table_select.forEach(_ => {
							let isTrue = true;
							for(let i = 0; i < _this.goods_select.length; i++) {
								if(_this.goods_select[i].goods_id == _.id && _this.goods_select[i].goods_type == '0') {
									isTrue = false;
								}
							}
							if(isTrue) {
								_this.goods_select.push({
									"goods_id": _.id,
									"goods_type": '0',
									"goods_name": _.name
								})
							}
						})
					} else {
						_this.goods_table_select.forEach(_ => {
							let isTrue = true;
							for(let i = 0; i < _this.goods_select.length; i++) {
								if(_this.goods_select[i].goods_id == _.id && _this.goods_select[i].goods_type == _.goods_type) {
									isTrue = false;
								}
							}
							if(isTrue) {
								_this.goods_select.push({
									"goods_id": _.id,
									"goods_type": _.goods_type,
									"goods_name": _.goods_name
								})
							}
						})
					}
					let arr = [];
					_this.goods_select.forEach(_ => {
						arr.push(_.goods_name);
					})
					_this.goods_txt = arr.join(',')
					_this.$refs.goods_table.clearSelection();
					layer.msg('保存成功');
                });
			},
			goodsDel() {
				this.goods_txt = '';
				this.goods_select = [];
			},

			getAllGoodsType: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getAllGoodsType', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"show_room_pack": -1//是否显示开房套餐 1是 -1否
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.goods_type_arr = res.data.response.result.data
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			// 打开适用商品类型选择弹窗
			typesSelect: function() {
				const _this = this;

				let c_choosed_goods_type = _this.choosed_goods_type
				let c_goods_type_all = _this.goods_type_all
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['600px', '500px'], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                    	_this.choosed_goods_type = c_choosed_goods_type
						_this.goods_type_all = c_goods_type_all
                    }
                }, function() {
					let arr = [];
					_this.choosed_goods_type.forEach(item => {
						_this.goods_type_arr.forEach(v => {
							if (v.id == item) {
								arr.push(v.name)
							}
						})
					})
					_this.types_txt = arr.join(',')
					layer.closeAll()
                }, function() {
                	_this.choosed_goods_type = c_choosed_goods_type
					_this.goods_type_all = c_goods_type_all
                });
			},

			typesDel() {
				this.types_txt = '';
				this.choosed_goods_type = [];
			},

			typesAll(val) {
                let ids = [];
				this.goods_type_arr.forEach(v => {
					ids.push(v.id);
				});
				this.choosed_goods_type = val ? ids : [];
			},
			typesChange(val) {
				const len = val.length;
				this.goods_type_all = len === this.goods_type_arr.length;
			},

			getGoodsPackageType() {
				const _this = this;

				_this.goods_type_list = [{
					id: "-2",
					name: "商品套餐",
					type: 'package',
					type_id: ''
				}];
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: '-2' + v.id,
								name: v.name,
								type: 'package',
								type_id: v.id
							});
						});
						_this.getGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			getGoodsType: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getGoodsType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: v.id,
								name: v.name
							});
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			goodsTypeChange(val) {
				this.goods_type_sign = val.type;
				if(this.goods_type_sign == 'package') {
					this.goods_type = val.type_id;
					this.goods_type_name = val.name;
				} else {
					this.goods_type = val.id;
					this.goods_type_name = val.name;
				}
				this.getGoodsTable(1);
			},
			getGoodsTable: function(page) {
				const _this = this;

				_this.loading = true;
				let url = "merchantGoods/searchMerchantGoodsList";
				let data = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.edit_form.shop_id,
							"goods_type": _this.goods_type,
							"goods_name": _this.goods_name,
						}
					},
					"comment": ""
				};
				if(_this.goods_type_sign == 'package') {
					url = "merchantGoods/searchMerchantGoodsPackage";
					data.request.param.status = '1';
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.goods_total = Number(res.data.response.result.data.total);
						}
						if(_this.goods_type_sign == 'package') {
							_this.goods_columns = [{
								"prop": 'name',
								"label": '名称'
							}, {
								"prop": 'package_unit_name',
								"label": '单位'
							}]
						} else {
							_this.goods_columns = [{
								"prop": 'goods_name',
								"label": '名称'
							}, {
								"prop": 'goods_unit_name',
								"label": '单位'
							}]
						}
						_this.goods_table = res.data.response.result.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			goodsQuery() {
				this.getGoodsTable(1);
			},
			getSelectGoods(val) {
				this.goods_table_select = val
			},
			// 添加、修改
			editSub() {
				const _this = this;

				let url = "FreeGoods/addData";
				let apply_role_ids = '-1';
				if(!_this.role_all) {
					apply_role_ids = _this.role_ids.join(',');
				}
				let goods_type = []
				if (_this.set_type == '2') {
					_this.choosed_goods_type.forEach(item => {
						_this.goods_type_arr.forEach(v => {
							if (item == v.id) {
								goods_type.push(v)
							}
						})
					})
				}
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.edit_form.shop_id,
							"name": _this.edit_form.name,
							"room_ids": _this.room_item,
							"use_all_room": _this.use_all_room,
							"use_every_day": _this.use_every_day,
							"start_date": _this.usedate_start,
							"end_date": _this.usedate_end,
							"use_start_time": _this.edit_form.use_start_time,
							"use_end_time": _this.edit_form.use_end_time,
							"week_cycle": _this.week_ids.join(','),
							"apply_role_ids": apply_role_ids,
							"set_type": _this.set_type,
							"goods_infos": _this.goods_select,
							"goods_type": goods_type,
						}
					},
					"comment": ""
				};
				if(_this.modify == '2') {
					url = "FreeGoods/editData";
					data.request.param.id = _this.edit_id;
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getListTable(_this.list_page);
						_this.showList = true;
						_this.showEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			backList() {
				this.showList = true;
				this.showEdit = false;
			}
        }
    }
</script>
<style lang="less" scoped>
    .cfr-edit {
		.el-form {
			width: 720px;
			.el-select {
				width: 450px;
				margin: 0 15px 0 0;
			}
			.el-input {
				width: 450px;
				margin: 0 15px 0 0;
			}
		}
		.cfr-usedate-wrap {
			position: relative;
			.usedate-everyday {
				label {
					margin: 0 0 10px 9px;
					font-weight: normal;
				}
			}
		}
	}
	.select-goods-wrap {
		display: none;
	}
	.role-pop,
	.goods-type-pop {
		.el-checkbox {
			width: 130px;
			margin-bottom: 10px;
		}
	}
</style>